/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { GetApiTagsIdQueryResponse, GetApiTagsIdPathParams, GetApiTagsId400, GetApiTagsId401, GetApiTagsId403, GetApiTagsId404, GetApiTagsId500 } from "../../types/GetApiTagsId.ts";
import { getApiTagsIdQueryResponseSchema } from "../../zod/TagSchemas/getApiTagsIdSchema.ts";

function getGetApiTagsIdUrl({ id }: { id: GetApiTagsIdPathParams["Id"] }) {
  const res = { method: 'GET', url: `/api/tags/${id}` as const }  
  return res
}

/**
 * @summary Получение жанра по идентификатору
 * {@link /api/tags/:Id}
 */
export async function getApiTagsId({ id }: { id: GetApiTagsIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GetApiTagsIdQueryResponse, ResponseErrorConfig<GetApiTagsId400 | GetApiTagsId401 | GetApiTagsId403 | GetApiTagsId404 | GetApiTagsId500>, unknown>({ method : "GET", url : getGetApiTagsIdUrl({ id }).url.toString(), ... requestConfig })  
  return getApiTagsIdQueryResponseSchema.parse(res.data)
}